import {
    BPMSResourcesManagementApiFactory,
    Configuration,
    LoanApplicationAgentAPIApiFactory,
    LoanApplicationBackofficeAPIApiFactory,
    MerchantBackofficeAPIApiFactory,
    PartnerBackofficeAPIApiFactory,
    ProcessDefinitionManagerApiFactory,
    TaskManagerApiFactory,
    TestDataAPIApiFactory,
    TransactionBackofficeAPIApiFactory,
    UISettingsApiFactory,
} from 'src/generated-api-client';
import { ResourceApiFactory } from 'src/services/customApi/ResourceApiFactory';

const apiConfig: Configuration | undefined = undefined;
const basePath = '';

const filesApiPath = '/api/file?';
export const getFileUrl = (filename: string) => {
    const searchParams = new URLSearchParams();
    searchParams.append('form', filename);

    return `${filesApiPath}${searchParams.toString()}`;
};

export const processDefinitionManagerApi = ProcessDefinitionManagerApiFactory(
    apiConfig,
    basePath,
);

export const taskManagerApi = TaskManagerApiFactory(apiConfig, basePath);
export const bpmsResourcesManagerApi = BPMSResourcesManagementApiFactory(
    apiConfig,
    basePath,
);

export const uiSettingsApi = UISettingsApiFactory(apiConfig, basePath);
export const merchantsApi = MerchantBackofficeAPIApiFactory(
    apiConfig,
    basePath,
);
export const loanApplicationsApi = LoanApplicationBackofficeAPIApiFactory(
    apiConfig,
    basePath,
);
export const partnersApi = PartnerBackofficeAPIApiFactory(apiConfig, basePath);

export const testDataApi = TestDataAPIApiFactory(apiConfig, basePath);

export const resourceApi = ResourceApiFactory(apiConfig, basePath);

export const agentLoanApplicationsApi = LoanApplicationAgentAPIApiFactory(
    apiConfig,
    basePath,
);

export const transactionApi = TransactionBackofficeAPIApiFactory(
    apiConfig,
    basePath,
);
